import React from 'react';
import { TConsumerItem, TConsumerListData } from '../../../types/data';
import { Separator } from '../../Separator/Separator';
import ListItems, { TListItemProps } from '../ListItems';
import styles from '../styles/styles.module.css';

type TListSectionItemsProps = {
    renderItem: React.FC<TListItemProps>;
    data: TConsumerListData;
};

const ListSectionItems = ({ data, renderItem }: TListSectionItemsProps) => {
    const sections = data?.sections;
    if (sections && Array.isArray(sections) && sections.length > 0) {
        return (
            <div className={styles.sectionsWrapper}>
                {sections.map((section) => {
                    const filteredItems = section.itemsIds.map((id) => {
                        if (data.items) {
                            return data.items?.find((item) => item.id === id);
                        }
                        return [];
                    }) as TConsumerItem[];
                    return (
                        <React.Fragment key={section.header}>
                            <Separator isWidget={false} separatorVariant={'subheader'} text={section.header.toLowerCase()} />
                            <ListItems items={filteredItems} renderItem={renderItem} />
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
    return null;
};
export default ListSectionItems;
